<template>
  <div class="mod-job-info mt10 mb10">
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <template v-for="(value,key,index) in columnNameHasMax">
        <preview-text-count
          :key="index"
          class="mb5"
          :class="[{'mt50' : (index === 0) && isMarginTop50}]"
          :name="value"
          :count-target="aboutApply[key]"
          :data-test="`text-count-${index + 1}`"
        />
      </template>
    </div>
    <dl v-if="aboutApply.homepageUrl">
      <dt>ホームページ</dt>
      <dd>
        <p data-test="homepage-url-company-name">
          {{ companyName }}
          <component
            :is="tag"
            :id="targetIdMap.homepageUrl"
            :href="aboutApply.homepageUrl"
            :class="{'link':isShowComment}"
            rel="nofollow"
            target="_blank"
            data-test="homepage-url"
          >
            {{ aboutApply.homepageUrl }}
          </component>
        </p>
      </dd>
    </dl>
    <dl>
      <dt>連絡先</dt>
      <dd>
        <p
          :id="targetIdMap.address"
          class="pega-pre-wrap"
          data-test="address"
          v-text="addressText"
        />
      </dd>
    </dl>
    <dl v-if="aboutApply.links.length">
      <dt>
        関連リンク
      </dt>
      <dd>
        <p
          v-for="(link,i) in aboutApply.links"
          :key="i"
        >
          <component
            :is="tag"
            :id="targetIdMap.links[i]"
            :href="link.url"
            :class="{'link':isShowComment}"
            rel="nofollow noopener noreferrer"
            target="blank"
            :data-test="`link-${i + 1}`"
          >
            {{ link.text }}
          </component>
        </p>
      </dd>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/preview/pc/base" as *;

span.link{
  color:#2473c2
}
.mt100{
  margin-top: 100px;
}
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import _ from 'lodash'

export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      required: true
    },
    aboutApply: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    columnNameHasMax () {
      const nameMap = {
        address: '住所',
        contactDepartment: '担当者',
        tel: 'TEL',
        contactEmail: 'E-mail'
      }
      if (!this.aboutApply.contactDepartment.value) delete nameMap.contactDepartment
      if (!this.aboutApply.tel.value) delete nameMap.tel
      if (!this.aboutApply.contactEmail.value) delete nameMap.contactEmail
      return nameMap
    },
    isMarginTop50 () {
      return this.aboutApply.homepageUrl
    },
    aTagCommentHighlights () {
      const aTagTargets = [
        this.targetIdMap.homepageUrl,
        ...this.targetIdMap.links
      ]
      return this.commentHighlights.filter((i) => aTagTargets.includes(i.target))
    },
    tag () {
      return this.isShowComment ? 'span' : 'a'
    },
    addressText () {
      return _.compact([
        `〒${this.aboutApply.zipcode}`,
        this.aboutApply.address.value.trim(),
        this.aboutApply.contactDepartment.value,
        this.aboutApply.tel.value ? `TEL / ${this.aboutApply.tel.value}` : '',
        this.aboutApply.contactEmail.value ? `E-mail / ${this.aboutApply.contactEmail.value}` : ''
      ]).join('\n')
    }
  },
  watch: {
    isShowComment: {
      async handler () {
        await this.$nextTick()
        this.aTagCommentHighlights.forEach((commentHighlight) => {
          this.setHighlight(commentHighlight)
        })
      }
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
